import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import { CircularProgress, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import shortid from 'shortid';
import theme from 'theme';
import { CssTextField } from './CssTextField';

const PREFIX = 'AutoCompleteSelect';

const classes = {
	formControl: `${PREFIX}-formControl`,
	selectEmpty: `${PREFIX}-selectEmpty`
};
const Root = styled('div')((
	{
		theme: Theme
	}
) => ({
	[`& .${classes.formControl}`]: {
		margin: 2,
		minWidth: '100%',
	},

	[`& .${classes.selectEmpty}`]: {
		marginTop: theme.spacing(2),
	}
}));

const CssAutoComplete = styled(Autocomplete)({
  '& label.Mui-focused': {
    color: '#042630',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#042630',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#042630',
    },
    '&:hover fieldset': {
      borderColor: '#042630',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#042630',
    },
  },
});

interface Props {
	name: string;
	label: string;
	handleOnChange: any;
	apiFunction: any;
	selectedProperty: any;
	value: any;
	isDisabled: any;
	focusApiFunction?: any;
	fullWidth?: boolean
}

const AutoCompleteSelect = (props: Props) => {
	const {
		name,
		label,
		handleOnChange,
		apiFunction,
		focusApiFunction,
		selectedProperty,
		value,
		isDisabled,
		fullWidth
	} = props;

	const [options, setOptions] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [selectValue, setSelectValue] = React.useState('');
	const [open, setOpen] = React.useState(false);

	const loading = open && options.length === 0;

	useEffect(() => () => setOptions([]), []);
	useEffect(() => {
		setSelectValue(value);
		setOptions([]);
		//setInputValue(value)
	}, [value]);
	useEffect(() => {
		setOptions([]);
		setSelectValue(value);
		//setInputValue(value)
	}, [value]);

	const handleSelectChange = (e: any, newValue: any) => {
		setSelectValue(newValue);
		const event: any = {};
		event.target = {};
		event.target.name = name;
		event.target.value = newValue;
		handleOnChange(event);
	};

	const handleInputChange = async (e: any, newInputValue: any) => {
		setInputValue(newInputValue);

		if (newInputValue !== null && newInputValue !== undefined) {
			if (newInputValue.length > 0) {
				try {
					const apiData = await apiFunction(newInputValue);
					console.warn('api data', apiData);
					setOptions(apiData);
				} catch (error) {
					console.log(error);
				}
			}
		}
	};
	const handleFocusChange = () => {
		if (focusApiFunction) {
			const data = async () => {
				const tempData: any = await focusApiFunction();
				setOptions(tempData);
			};
			data();
		}

	};

  const getOptionLabel = (option:any) => {
    // Check if the option has a campaignName property
    if (option && option[selectedProperty]) {
      return option[selectedProperty]; // Return the campaignName as the label
    }
    return ""; // Return an empty string if the label is not found
  };

	return (
		<Root>
			<CssAutoComplete
				id={shortid.generate()}
				className={classes.formControl}
				open={open}
				options={options}
				fullWidth={true}
				isOptionEqualToValue={(option: any, value: any) =>
					option[selectedProperty] === value[selectedProperty]
				}
				// getOptionLabel={(option: any) => option[selectedProperty]}
      getOptionLabel={getOptionLabel}

				style={{ width: 300 }}
				value={selectValue}
				//inputValue={value}
				disabled={isDisabled}
				onOpen={() => {
					setOpen(true);
				}}
				onClose={() => {
					setOpen(false);
				}}
				onChange={handleSelectChange}
				onFocus={handleFocusChange}
				inputValue={inputValue}
				loading={loading}
				onInputChange={handleInputChange}
				renderInput={(params) => (
					<CssTextField
						{...params}
						fullWidth
						id={shortid.generate()}
						label={label}
						name={name}
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<Root>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Root>
							),
						}}
					/>
				)}
			/>
		</Root>
	);
};

export default AutoCompleteSelect;
